import React from 'react';
import { ChevronLeft, ChevronRight, Star, Music2 } from 'lucide-react';
import { Poem } from '../../types';
type PoemSelectorProps = {
  poems: Poem[];
  selectedPoem: Poem;
  onSelect: (poem: Poem) => void;
};
export function PoemSelector({
  poems,
  selectedPoem,
  onSelect
}: PoemSelectorProps) {
  const currentIndex = poems.findIndex(p => p.id === selectedPoem.id);
  const handlePrevious = () => {
    const newIndex = (currentIndex - 1 + poems.length) % poems.length;
    onSelect(poems[newIndex]);
  };
  const handleNext = () => {
    const newIndex = (currentIndex + 1) % poems.length;
    onSelect(poems[newIndex]);
  };
  return <div className="w-full max-w-2xl mx-auto mb-8" data-id="element-257">
      <div className="flex items-center justify-between bg-white rounded-2xl shadow-lg p-4 border-2 border-gray-100" data-id="element-258">
        <button onClick={handlePrevious} className="p-2 rounded-full hover:bg-gray-100 text-gray-600 transition-colors" aria-label="Previous poem" data-id="element-259">
          <ChevronLeft className="w-8 h-8" data-id="element-260" />
        </button>

        <div className="flex-1 px-4 text-center" data-id="element-261">
          <div className="flex items-center justify-center space-x-2 mb-1" data-id="element-262">
            <span className="px-2 py-0.5 bg-[#C41E3A]/10 text-[#C41E3A] text-xs font-bold rounded-full" data-id="element-263">
              {selectedPoem.dynasty}
            </span>
            <span className="text-gray-500 text-sm" data-id="element-264">{selectedPoem.author}</span>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2" data-id="element-265">
            {selectedPoem.title}
          </h2>

          <p className="text-gray-600 text-lg font-medium font-serif" data-id="element-266">
            "{selectedPoem.firstLine}..."
          </p>

          <div className="flex justify-center items-center mt-3 space-x-4" data-id="element-267">
            <div className="flex items-center text-yellow-500" data-id="element-268">
              {[...Array(selectedPoem.difficulty)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-269" />)}
            </div>
            <div className="flex items-center text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded-md" data-id="element-270">
              <Music2 className="w-3 h-3 mr-1" data-id="element-271" />
              {selectedPoem.mode}
            </div>
          </div>
        </div>

        <button onClick={handleNext} className="p-2 rounded-full hover:bg-gray-100 text-gray-600 transition-colors" aria-label="Next poem" data-id="element-272">
          <ChevronRight className="w-8 h-8" data-id="element-273" />
        </button>
      </div>
    </div>;
}